module.exports = "<div class=\"splash-content\">\n  <div id=\"flashMessages\">\n    <div class=\"flash-message alert alert-danger\">\n      {{'EXTERNAL_LOGIN_EXPIRED.LOG_IN_AGAIN' | translate}}\n    </div>\n  </div>\n  <div class=\"splash-container\">\n    <div class=\"login-logo error\"><span class=\"sr-only\">Onyx CenterSource</span></div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/auth/external-login-expired/external-login-expired.component.html
// module id = o9sb
// module chunks = 0